import { render, staticRenderFns } from "./NewCalendarItem.vue?vue&type=template&id=ec99a4ac&"
import script from "./NewCalendarItem.vue?vue&type=script&lang=js&"
export * from "./NewCalendarItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/devteam/projects/dominion-conference-app/ConferenceAdmin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports